<nav class="layout-breadcrumb" [attr.aria-label]="'ACCESSIBILITY.BREADCRUMB_NAV' | translate">
  <ol>
    @for (item of breadcrumbs$ | async; track $index; let last = $last) {
      <li [attr.aria-current]="last ? 'page' : null">{{ item.label }}</li>
      @if (!last) {
        <li class="layout-breadcrumb-chevron" aria-hidden="true">/</li>
      }
    }
  </ol>
</nav>
